import { mapToCanActivate, mapToCanDeactivate, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { SdohPermissionsEnum } from './core/constants/permissions.enum';
import { TabsType } from '@core/model';
import { SdohReferralPreloadResolver } from './core/resolvers/sdoh-referral-preload.resolver';
import { CanDeactivateCreateSubmissionGuard } from './core/guards/can-deactivate-create-submission.guard';
import { CanDeactivateEditSubmissionGuard } from './core/guards/can-deactivate-edit-submission.guard';
import { AccessDataEditGuard } from './core/guards/access-data-edit.guard';
import { AccessDataPreviewGuard } from './core/guards/access-data-preview.guard';
import { HomePageComponent } from './pages/home-page/home-page.component';

const routes: Routes = [
    {
        path: 'sdoh',
        children: [
            {
                path: '',
                component: HomePageComponent,
                pathMatch: 'full'
            },
            {
                path: ':tId/form/:rId/:formType/add',
                loadComponent: () => import('@feature/assessment-form/assessment-form-create/assessment-form-create.component')
                    .then(i => i.AssessmentFormCreateComponent),
                data: {
                    permissions: [
                        SdohPermissionsEnum.SUBMISSION_WRITE
                    ]
                },
                //canActivate: mapToCanActivate([MsalGuard]),
                canDeactivate: mapToCanDeactivate([CanDeactivateCreateSubmissionGuard]),
                resolve: {
                    referral: SdohReferralPreloadResolver
                }
            },
            {
                path: ':tId/form/:rId/:formType/:sId/edit',
                loadComponent: () => import('@feature/assessment-form/assessment-form-edit/assessment-form-edit.component')
                    .then(i => i.AssessmentFormEditComponent),
                data: {
                    permissions: [
                        SdohPermissionsEnum.SUBMISSION_READ,
                        SdohPermissionsEnum.SUBMISSION_WRITE,
                        SdohPermissionsEnum.EXPIRED_SUBMISSION_UPDATE
                    ]
                },
                canActivate: mapToCanActivate([AccessDataEditGuard]),
                //canActivate: mapToCanActivate([MsalGuard, AccessDataEditGuard]),
                canDeactivate: mapToCanDeactivate([CanDeactivateEditSubmissionGuard])
            },
            {
                path: ':tId/form/:rId/:formType/:sId/preview',
                loadComponent: () => import('@feature/assessment-form/assessment-form-view/assessment-form-view.component')
                    .then(i => i.AssessmentFormViewComponent),
                data: {
                    permissions: [
                        SdohPermissionsEnum.SUBMISSION_READ
                    ]
                },
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard, AccessDataPreviewGuard])
                canActivate: mapToCanActivate([AccessPageGuard, AccessDataPreviewGuard])
            },
            {
                path: ':tId/referrals/:rId',
                loadComponent: () => import('@feature/referral-form/referral-form.component')
                    .then(i => i.ReferralFormViewComponent),
                data: {
                    permissions: [
                        SdohPermissionsEnum.ASSESSMENT_READ
                    ]
                },
                canActivate: mapToCanActivate([AccessPageGuard])
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            },
            {
                path: 'pending-referrals',
                loadComponent: () => import('@pages/pending-referrals-page/pending-referrals-page.component')
                    .then(i => i.PendingReferralsPageComponent),
                data: {
                    permissions: [
                        SdohPermissionsEnum.ASSESSMENT_READ,
                        SdohPermissionsEnum.PENDING_REFERRAL_READ
                    ]
                },
                canActivate: mapToCanActivate([AccessPageGuard])
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            },
            {
                path: 'my-referrals',
                loadComponent: () => import('@pages/referral-manager-page/referral-manager-page.component')
                    .then(i => i.ReferralManagerPageComponent),
                data: {
                    permissions: [SdohPermissionsEnum.ASSESSMENT_READ],
                    tab: TabsType.MyReferrals
                },
                canActivate: mapToCanActivate([AccessPageGuard])
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            },
            {
                path: 'all-referrals',
                loadComponent: () => import('@pages/referral-manager-page/referral-manager-page.component')
                    .then(i => i.ReferralManagerPageComponent),
                data: {
                    permissions: [SdohPermissionsEnum.ASSESSMENT_READ],
                    tab: TabsType.AllReferrals
                },
                canActivate: mapToCanActivate([AccessPageGuard])
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            },
            {
                path: 'archive',
                loadComponent: () => import('@pages/referral-manager-page/referral-manager-page.component')
                    .then(i => i.ReferralManagerPageComponent),
                data: {
                    permissions: [SdohPermissionsEnum.ASSESSMENT_READ],
                    tab: TabsType.Archived
                },
                canActivate: mapToCanActivate([AccessPageGuard])
                //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            },
            // {
            //     path: '',
            //     component: DefaultSdohComponent,
            //     pathMatch: 'full',
            //     data: { permissions: [SdohPermissionsEnum.ASSESSMENT_READ] },
            //     canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
            // }
        ]
    },
    {
        path: 'analytics',
        data: {
            permissions: [SdohPermissionsEnum.ANALYTICS_READ]
        },
        children: [
            { path: '', redirectTo: 'sdoh', pathMatch: 'full' },
            {
              path: 'sdoh',
              loadComponent: () => import('@feature/analytics/sdoh-analytics/sdoh-analytics.component').then(i => i.SdohAnalyticsComponent),
              data: { analytics: true }
            }
          ]
        //canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
    },
    {
        path: '**',
        redirectTo: 'sdoh'
    }
    // {
    //   path: 'page401',
    //   component: AccessDeniedComponent,
    //   data: { title: 'Access Denied' },
    //   canActivate: mapToCanActivate([MsalGuard])
    // }
]


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class MncSDoHRoutingModule { }